import { gql } from 'apollo-angular';

export const CONDITION_FRAGMENT = gql`
  fragment ConditionFragment on Condition {
    id
    vat
    type
    surcharge
    discount
    plCustomerCode
    externalSystemId
  }
`;
